import { propOr } from 'ramda';
import { createSelector } from 'reselect';

export const uiSelector = (state) => state.ui;
export const configSelector = (state) => state.config;

export const isParentWindowFullscreenSelector = createSelector(
  uiSelector,
  propOr(false, 'isParentWindowFullscreen')
);

export const isEvoWrappedSelector = createSelector(
  configSelector,
  propOr(false, 'isEvoWrapped')
);
